import Climate from "../Images/Weather0.jpg";
import BMI from "../Images/bmi.jpg";
import ACM from "../Images/acmprojectimg.jpg"
import Portfolio from "../Images/portfolioproject.jpg"
import Guideselection from "../Images/guideselectionportal.jpg"

const ProjectData = [
  {
    title: "Guide Selection Portal",
    description:
    "The Guide Selection Portal streamlines mentor-student connections for projects. It simplifies guide selection with mentor data such as name, email, and domain. The portal prevents duplicate registrations, ensuring accurate guide assignments. It securely stores project details and allows easy document uploads and updates. Students can access mentor reviews, fostering efficient collaboration and project excellence. The user-friendly interface transforms the mentor-student dynamic, promoting seamless communication and precision in assignments.",
    repo: "https://github.com/Guideselection/Giuide-Selection-Frontend-21-25",
    imgsrc: Guideselection,
  },
  {
    title: "Climate Check",
    description:
      "I recently developed a weather website using a variety of technologies, including an API for retrieving weather data, Node.js for server-side scripting, Express.js for routing, and HTML for the front-end user interface. The website allows users to input their location and view current weather conditions.",
    repo: "https://github.com/Bogeshwararao/Weather-Report-",
    imgsrc: Climate,
  },
  {
    title: "Portfolio",
    description:"I am excited to announce the recent launch of a website I developed for showcase My work.The website was built using the React.js and Bootstrap frameworks to provide a responsive.Overall, we believe that the combination of React.js and Bootstrap has allowed us to create a fast,and user-friendly website",
    repo: "https://github.com/Bogeshwararao/bogesh",
    imgsrc: Portfolio,
  },
  {
    title: "Official ACM website",
    description:"I'm happy to describe the website I have developed for a community using MERN stack services.The website you have built is a feature-rich, full-stack web application that is built using MongoDB,Express,React and Node.js.The MERN stack services have been used to create a enjoyable user experience for the community.",
    repo: "https://github.com/Bogeshwararao/B.M.I",
    imgsrc:ACM,
  },
  {
    title: "B.M.I",
    description:"I have developed a BMI calculator using Express and Node.js, which can be accessed through an HTML interface. The BMI calculator takes in a person's weight and height as input and calculates their BMI, which is a measure of body fat based on their weight in relation to their height.",
    repo: "https://github.com/Bogeshwararao/B.M.I",
    imgsrc:BMI,
  },
];

export default ProjectData;
